import type { ChipProps as MuiChipProps } from '@mui/material/Chip'
import MuiChip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'

export type ChipColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'success'
  | 'warning'
  | 'info'
  | 'default'
export type ChipSize = 'small' | 'medium'

interface CustomChipProps
  extends Omit<MuiChipProps, 'color' | 'size' | 'label' | 'onDelete'> {
  label: string
  onDelete?: () => void
  size?: ChipSize
  color?: ChipColor
  clickable?: boolean
  variant?: 'filled' | 'outlined'
}

export default function CustomChip({
  label,
  onDelete,
  size = 'medium',
  color = 'default',
  clickable = false,
  variant = 'filled',
  sx,
  ...rest
}: CustomChipProps) {
  const theme = useTheme()

  const getChipColor = (colorType: ChipColor) => {
    if (colorType === 'default') {
      return theme.palette.text.primary
    }
    return theme.palette[colorType].main
  }

  const baseColor = getChipColor(color)

  return (
    <MuiChip
      label={label}
      onDelete={onDelete}
      size={size}
      clickable={clickable}
      variant={variant}
      sx={{
        ...(variant === 'filled'
          ? {
              color: theme.palette.background.paper,
              backgroundColor: baseColor,
              '&:hover': {
                backgroundColor: baseColor,
                opacity: 0.9,
              },
              '&.MuiChip-clickable:hover': {
                backgroundColor: baseColor,
                opacity: 0.8,
              },
            }
          : {
              color: baseColor,
              borderColor: baseColor,
            }),
        '& .MuiChip-deleteIcon': {
          color: '#000000',
          opacity: '0.7',
          borderRadius: '50%',
          margin: 0,
          height: '17px',
          width: '17px',
        },
        '& .MuiChip-deleteIcon:hover': {
          color: '#000000',
          opacity: '0.7',
        },

        ...sx,
      }}
      {...rest}
    />
  )
}
